//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ChangeColMixin } from '@/mixins/ChangeColMixin1';
import moment from 'moment/moment';
export default {
  mixins: [ChangeColMixin],
  data: function data() {
    return {
      visible: false,
      ipagination: {
        current: 1,
        pageSize: 12,
        pageSizeOptions: ['12', '24', '48'],
        showTotal: function showTotal(total, range) {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      loading: false
    };
  },
  methods: {
    handleCancel: function handleCancel() {
      this.visible = false;
    },
    initData: function initData(date) {
      var _this = this;

      this.queryParam.st = window.sessionStorage.getItem('siteType');
      this.siteType = window.sessionStorage.getItem('siteType');
      this.queryParam.upStandard = 0;
      this.queryParam.scope = 1;
      this.queryParam.scopeId = window.sessionStorage.getItem('siteId');
      window.sessionStorage.getItem('siteType') ? this.url = '/online/st' + window.sessionStorage.getItem('siteType') + '/cn2061' : '';
      window.addEventListener('setItem', function (e) {
        if (e.key == 'siteType') {
          _this.url = '/online/st' + window.sessionStorage.getItem('siteType') + '/cn2061';
        }
      });
      this.queryParam.stime = moment(date).format('YYYY-MM-DD HH:mm:ss');
      this.queryParam.etime = moment(moment(date) + 24 * 60 * 60 * 1000 - 1).format('YYYY-MM-DD HH:mm:ss');
      this.loadData();
    }
  }
};